<template>
  <div>
    <div class="card card-custom gutter-b">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label">
            {{ device.name }}
          </h3>
        </div>
        <div class="card-toolbar">code: {{ device.code }}</div>
      </div>
      <div class="card-body">
        <component
          v-if="loaded"
          v-bind:is="currentComponent"
          :ref="currentComponent"
          :status.sync="status"
          @change-form="updateStatus"
        ></component>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import { FETCH_DEVICE } from "@/core/services/store/devices.module";
import { mapGetters } from "vuex";
import ECS1 from "@/view/pages/devices/comps/ECS1";
import TP1 from "@/view/pages/devices/comps/TP1";
import TP2 from "@/view/pages/devices/comps/TP2";
import TP4 from "@/view/pages/devices/comps/TP4";
import PR1 from "@/view/pages/devices/comps/PR1";
import VLV from "@/view/pages/devices/comps/VLV";
import RGB from "@/view/pages/devices/comps/RGB";
import TEP from "@/view/pages/devices/comps/TEP";
import { SET_TERMINAL_DEVICE } from "@/core/services/store/terminal.module";

export default {
  name: "dashboard",
  components: {
    ECS1,
    TP1,
    TP2,
    TP4,
    PR1,
    VLV,
    RGB,
    TEP
  },
  data() {
    return {
      loaded: false,
      status: "333"
    };
  },
  mounted() {
    this.$store.dispatch(SET_ACTIONS, {});

    this.getDevice().then(() => {
      this.$store.dispatch(SET_BREADCRUMB, [{ title: this.device.name }]);

      this.$store.dispatch(SET_TERMINAL_DEVICE, this.device);

      this.eventHub.$on(`update_device_${this.device.code}`, val => {
        this.status = val;
      });
    });
  },
  computed: {
    ...mapGetters(["device"]),
    currentComponent: function() {
      return this.$store.state.devices.typesEnum[this.device.type];
    }
  },
  methods: {
    getDevice() {
      return new Promise(resolve => {
        this.loaded = false;

        this.$store
          .dispatch(FETCH_DEVICE, this.$route.params.id)
          .then(data => {
            this.status = data.status;
            this.loaded = true;
            resolve();
          })
          .catch(() => {
            this.loaded = true;
          });
      });
    },
    updateStatus(s) {
      this.eventHub.$emit("set_device_status", {
        code: this.device.code,
        query: `SET STA ${s}`
      });

      // this.eventHub.$emit("re_render_page", this);
    }
  }
};
</script>
